module.exports = __webpack_public_path__ + "img/devhaus.ab1a7289.png";